export default class UpdateSpecOutGeneralDetailsRequest {
    updatedAt: Date = new Date();
    ownerId = '';
    branchId = '';
    deskId: string = null;
    workerId = '';
}
